import { defineComponent as _defineComponent } from 'vue'
import { ScanGift } from '@tencent/wphk-components-scan-gift';
import MerchantsDialog from './merchants-dialog.vue';
import { ref, onBeforeMount, computed, onMounted } from 'vue';
import { useConfigStore } from '@/store';
import { ScanGiftInfo } from '@/types';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';
import dayjs from 'dayjs';
import { to } from '@tencent/wphk-base-utils';
import { CustomException, windowHelper } from '@tencent/ppd-base-libs';
import { storeToRefs } from 'pinia';
import { handleSetWxShareInfo } from '@/business';
import { CouponGuide } from '@tencent/wphk-components-coupon-guide';
import { isReturningHKUser } from '@/api';
import { CouponState } from '@tencent/wphk-act-base-types';
import { MAINLAND_COUPON_GUIDE_POSID } from '@/config/module-config/mainland';
import { DP_PAGE } from '@/config/dp';
import { MAINLAND_DIALOG_NAME } from '@/config/dialog';
import { onMittDialogReady } from '@tencent/wphk-components-dialog-manager';
import { i18n } from '@/i18n';



export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['isReady'],
  setup(__props, { emit: emits }) {


const configStore = useConfigStore();
const { currentAreaWxShareConf } = storeToRefs(configStore);

/** 扫码有礼组件 */
const scanGift = ref<InstanceType<typeof ScanGift> | null>(null);
/** 覆盖扫码有礼的券配置 */
const couponConfig = { couponTagText: '', themeColor: 'green' };
const isShowScanGift = ref(false);
const data = ref<ScanGiftInfo | null>(null);
const isShowDialog = ref(false);
const { getScanGiftInfo } = useConfigStore();
const spId = computed(() => data.value?.spId || '');
const campaignId = computed(() => data.value?.campaignId || '');
const bannerDetail = computed(() => data.value?.bannerDetail);
const bannerJumpUrl = computed(() => data.value?.bannerJumpUrl);
const banner = computed(() => data.value?.banner || '');
// 是否展示底部banner
const isShowBar = computed(() => {
  const hasBannerOptions = bannerDetail.value?.content || bannerJumpUrl.value;
  if (data.value && banner.value && hasBannerOptions) {
    const { startTime, endTime } = data.value;
    const now = getServerTime();
    return dayjs(startTime).isBefore(now) && dayjs(endTime).isAfter(now);
  }
  return false;
});

const isShowC2CPrompt = ref(false);

onBeforeMount(async () => {
  const [err, res] = await to(getScanGiftInfo());
  if (err) {
    new CustomException(err, 'getScanGiftInfoException', 'get scan gift config fail');
  } else {
    data.value = res;
    if (!spId.value || !campaignId.value) {
      emits('isReady', false);
    }
  }
});

/** 查看商户列表 */
function handleView() {
  if (bannerJumpUrl.value) {
    windowHelper.redirect(bannerJumpUrl.value, 300);
  } else {
    isShowDialog.value = true;
  }
}

function handleClose() {
  isShowDialog.value = false;
}

function onRestWxShare() {
  // 设置微信分享
  handleSetWxShareInfo(currentAreaWxShareConf.value);
}
// 是否新用户
const isNewUser = ref(false);
onMounted(async () => {
  const [err, result] = await to(isReturningHKUser());
  if (err || !result) return;
  isNewUser.value = true;
});

function onShowAnyC2CDialog(isShow) {
  isShowC2CPrompt.value = isShow;
  onMittDialogReady({ dialogKey: MAINLAND_DIALOG_NAME.C2C_DIALOG_NAME, isDialogVisible: isShow });
}

function isReceiveCoupon(coupon) {
  return [CouponState.expired, CouponState.used, CouponState.received].includes(coupon.couponState);
}

const isShowCouponGuide = ref(false);
function handleCompReady(isReady: boolean, data) {
  // 根据券状态判断是否展示couponGuide组件
  emits('isReady', isReady, data);
  isShowScanGift.value = isReady;
  const activeCoupon = data.fixedCouponDetailList
    .filter(item => item.couponState !== CouponState.used && item.couponState !== CouponState.expired);
  isShowCouponGuide.value = activeCoupon.length !== 0 && isNewUser.value;

  if (!isReady) {
    onMittDialogReady({ dialogKey: MAINLAND_DIALOG_NAME.SCAN_GIFT_DIALOG_NAME, isDialogVisible: false });
    return;
  }
  const list = data.fixedCouponDetailList;
  const isAllScanGiftCouponNotReceived = list.every(item => !isReceiveCoupon(item));
  onMittDialogReady({
    dialogKey: MAINLAND_DIALOG_NAME.SCAN_GIFT_DIALOG_NAME,
    isDialogVisible: isAllScanGiftCouponNotReceived,
    showDialog: () => {
      scanGift.value?.showPromptDialog();
    },
  });
}

return { __sfc: true,emits, configStore, currentAreaWxShareConf, scanGift, couponConfig, isShowScanGift, data, isShowDialog, getScanGiftInfo, spId, campaignId, bannerDetail, bannerJumpUrl, banner, isShowBar, isShowC2CPrompt, handleView, handleClose, onRestWxShare, isNewUser, onShowAnyC2CDialog, isReceiveCoupon, isShowCouponGuide, handleCompReady, ScanGift, MerchantsDialog, CouponGuide, MAINLAND_COUPON_GUIDE_POSID, DP_PAGE, i18n }
}

})